import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ClientModel } from '../domain/Shared/client';
import { EInterventionType } from '../domain/planning/enum/intervention-type';
import { CoreData } from '../tools/core-data';
import { LoadingTask } from '../tools/loading-task';
import { BaseService } from './base-service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class ClientService extends BaseService {

    private serviceUrl = `${environment.serviceMainBaseUrl}api/client`;

    constructor(
        protected http: HttpClient,
        protected coreData: CoreData,
        protected loadingTask: LoadingTask,
        protected snackBare: MatSnackBar,
        protected router: Router,
        ) {
            super(coreData, router, snackBare);
    }

    getClientAndInterventionByDateAndName(searchText: string, fromDate: Date, toDate: Date, interventionType?: EInterventionType) {
        this.loadingTask.activateLoading();
        return this.http.get(
            `${this.serviceUrl}/${encodeURI(moment(fromDate).format('yyyy-MM-DD'))}/${encodeURI(moment(toDate).format('yyyy-MM-DD'))}/${interventionType ? interventionType : 0}?name=${encodeURI(searchText)}`,
            this.generateHeader()).pipe(
                catchError(this.handleError<any>('getClientWithInterventionDoneByFilter')),
                finalize(() => this.loadingTask.deactivateLoading()),
                map((response: ClientModel[]) => {
                    return response.map((item: ClientModel) => {
                        return ClientModel.mapFromJSON(item);
                    });
                })
            );
    }
}
